import Alpine from "alpinejs"

Alpine.store("nav", {
  showMobileNav: false,
})
